<template>
    <v-card flat>
        <v-img max-width="400" src="/images/error.png" lazy-src="/images/error.png" aspect-ratio="1.6" class="mx-auto">
            <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
            </template>
        </v-img>
        <p v-if="title != ''" class='text-center headline font-weight-bold grey--text text--darken-1 mt-3 mb-0'>{{title}}</p>
        <p v-if="description != ''" class='text-center font-weight-bold grey--text' v-html="description"></p>
        <p class="text-center"><v-btn color="primary" small class="text-capitalize" :to="button.path">{{button.title}}</v-btn></p>
    </v-card>
</template>

<script>
export default {
    props: ['title', 'description', 'button']
}
</script>